<template>
  <div id="terms" class="overlay agreement">
    <div class="inner_static">
      <div class="inner_box">
        <a class="btn_close" @click="btnCloseClick()"></a>
        <h5 class="tit_agreement">カグル 利用規約</h5>
        <dl class="lst_agreement">
          <dt>・本サービスのご利用</dt>
          <dd>
            本サービス内で入手できるすべてのポリシーを遵守してください。
          </dd>
          <dd>
            本サービスを不正に利用しないでください。たとえば、本サービスの妨害や、Google が提供するインターフェースおよび手順以外の方法による本サービスへのアクセスを試みてはなりません。ユーザーは、法律（輸出、再輸出に関して適用される法規制を含みます）で認められている場合に限り、本サービスを利用することができます。ユーザーが Google の規約やポリシーを遵守しない場合、または Google が不正行為と疑う行為について調査を行う場合に、Google はユーザーに対する本サービスの提供を一時停止または停止することができます。
          </dd>
          <dd>
            ユーザーは、本サービスを利用することによって、本サービスまたはアクセスするコンテンツに対するいかなる知的財産権も取得することはありません。ユーザーは、本サービスのコンテンツの所有者から許可を得た場合や、法律によって認められる場合を除き、そのコンテンツを利用することはできません。本規約は、本サービスで使用されている、いかなるブランドまたはロゴを利用する権利もユーザーに与えるものではありません。本サービス内に表示される、または、本サービスに伴って表示されるいかなる法的通知も、削除したり、隠したり、改ざんしてはなりません。
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    btnCloseClick: function (event) {
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var elements = document.getElementsByClassName('agreement')
      // 配列に変換
      var array = Array.prototype.slice.call(elements)
      var target = array.find(p => p.classList.contains('open'))
      var bodyElements = document.getElementsByTagName('body')
      if (target) {
        target.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        target.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/Terms.vue